import {
  descriptionUI,
  selectSchema,
  selectUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validateTotalFileSize } from 'platform/shared/health-apps';
import FileUploadDescription from '../../../../components/FormDescriptions/FileUploadDescription';
import {
  attachmentSchema,
  attachmentUI,
} from '../../../../definitions/attachments';
import content from '../../../../locales/en/content.json';
import { DISCHARGE_DOC_TYPES } from '../../../../utils/constants';

const TITLE_TEXT = content['service-info--attachments-upload-title'];
const INPUT_LABELS = {
  item: content['service-info--attachments-file-label'],
  type: content['service-info--attachments-type-label'],
};

const SCHEMA_ENUM = Object.keys(DISCHARGE_DOC_TYPES);

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...descriptionUI(FileUploadDescription),
    attachmentFile: attachmentUI({
      title: INPUT_LABELS.item,
    }),
    attachmentId: selectUI({
      title: INPUT_LABELS.type,
      labels: DISCHARGE_DOC_TYPES,
    }),
    'ui:options': { useAllFormData: true },
    'ui:validations': [validateTotalFileSize()],
  },
  schema: {
    type: 'object',
    required: ['attachmentFile', 'attachmentId'],
    properties: {
      attachmentFile: attachmentSchema,
      attachmentId: selectSchema(SCHEMA_ENUM),
    },
  },
};
